import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '$store/rootReducer';
import { AddListMemberState } from '$store/addListMember/interface';
import { LoadingStatus } from '$store/reels/interface';

const currentDate = new Date();

const initialState: AddListMemberState = {
  loadingStatus: 'loading',
  members: [],
  query: '',
};

export const { actions, reducer } = createSlice({
  name: 'addListMember',
  initialState,
  reducers: {
    loadMembers(state) {
      state.loadingStatus = 'loading';
    },
    setQuery(state, action: PayloadAction<string>) {
      state.query = action.payload;
    },
    setLoadingStatus(state, action: PayloadAction<LoadingStatus>) {
      state.loadingStatus = action.payload;
    },
    setMembers(state, action: PayloadAction<number[]>) {
      state.members = action.payload;
    },
  },
});

export { reducer as addListMemberReducer, actions as addListMemberActions };

export const addListMemberSelector = (state: RootState) => state.addListMember;
